export default __webpack_public_path__ + "static/media/comingsoon.435b5a27.png";